import { i18n, moment } from '@international/mastodon-i18n';
import resources from './lib/translations/resources';

import { isInternational } from './lib/helpers';

const I18N_LOCALE_COOKIE = 'checkr_locale';

const hasCookie = (name: string) => {
  return document.cookie.split(';').some(c => {
    return c.trim().startsWith(`${name}=`);
  });
};

const initializeTranslations = () => {
  const international = isInternational();
  let currentLocale = i18n.defaultLocale;
  let redirectUrl = null;

  if (international && window?.location?.href) {
    const url = new URL(window.location.href);
    if (url.searchParams.has('lang')) {
      currentLocale = url.searchParams.get('lang');
      url.searchParams.delete('lang');
      redirectUrl = url;
    } else if (hasCookie(I18N_LOCALE_COOKIE)) {
      currentLocale = i18n.getCookieLocale();
    } else {
      const req = (window as any).env?.req || {};
      const region = req['cf-region'] ? req['cf-region'].toLowerCase() : '';
      if (region === 'quebec' || region === 'qc') {
        currentLocale = 'fr';
      } else {
        currentLocale = i18n.getCookieLocale();
      }
    }
  }
  i18n.init({ resources: resources() });
  i18n.setLocale({
    value: currentLocale,
    resources: resources(),
    country: international ? i18n.getWorkLocation() : null,
  });

  if (!international) {
    moment.locale(i18n.defaultLocale);
  }
  if (document?.documentElement?.lang) {
    document.documentElement.lang = currentLocale;
  }
  if (redirectUrl) {
    window.history.pushState({}, '', redirectUrl.href);
  }
};

export default initializeTranslations;
